import { fill } from './fill.js'
import { FreeTrialReportCardProvincialGr912202202Sem as Page } from './Page.jsx'
import templateUrl from './template.pdf'

export default {
  key: 'pvrc9to12_2022_02_sem',
  label: 'Provincial Report - Gr. 9–12',
  templateUrl,
  fill,
  Page,
}
